import { takeLatest } from "redux-saga/effects";
import { HomeActionTypes } from "../actions/actionTypes";
import { skeletonStore } from "../../../store";
import { SkeletonActionCreators } from "../../../actions/actionCreators";

function* logout(action) {
    localStorage.removeItem("sessionid");
    skeletonStore.dispatch(SkeletonActionCreators.initialize());
}

export function* logoutWatcher() {
    yield takeLatest(HomeActionTypes.LOGOUT, logout);
}
